export default __webpack_public_path__ + "static/media/about.4a4c9f8a.png";